module.exports = __webpack_public_path__ + "img/title9.b371e001.png";